import { useEffect, useState } from 'react'
import {
  APPLICATION_PREFERENCES,
  FIELD_VALUE_CONSTANTS,
} from '../../utils/constants'
import {
  ConfirmDialog,
  CustomButton,
  CustomTable,
  FormInput,
  Pagination,
  SORT_KEYS,
  TableActionType,
  TableColumnType,
} from '@ui-kit'
import { useForm } from 'react-hook-form'
import {
  ShiftDetails,
  ShiftTimingFormType,
  ShiftTimingProps,
} from '../../types/applicationPreferences.types'
import {
  addToaster,
  DataType,
  DataTypeStore,
  hideLoader,
  showLoader,
  useDispatch,
} from '@app-store'
import { APPLICATION_PREFERENCES_STRINGS } from '../../utils/strings'
import {
  convertISOToDate,
  convertISOToTime,
  convertTimeToISO,
  convertTo24HourFormat,
  convertToCamelCase,
} from '../../utils/helperFunctions'
import { isEmpty, noop } from 'lodash'
import {
  addShiftData,
  getShiftsData,
  patchShift,
  updateShiftData,
} from '../../apis/applicationPreferences.api'
import { v4 as uuid } from 'uuid'
import moment from 'moment'
const ShiftTiming = ({
  setEditState,
  editState,
  provideSetData,
  shortKey,
}: ShiftTimingProps) => {
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState<number>(
    FIELD_VALUE_CONSTANTS.ONE
  )
  const [totalPages, setTotalPages] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(
    FIELD_VALUE_CONSTANTS.TEN
  )
  const [data, setData] = useState<DataType[]>([])
  const [sortDirection, setSortDirection] = useState<{
    keyName: string
    direction: SORT_KEYS
    isAsc: SORT_KEYS
    key: string
  }>({
    key: 'effective_end_date',
    isAsc: SORT_KEYS.Asc,
    keyName: 'effectiveEndDate',
    direction: SORT_KEYS.Asc,
  })
  const [modal, setModal] = useState<{
    type: string
    state: boolean
    index: number | undefined
  }>({
    type: '',
    state: false,
    index: undefined,
  })
  const ShiftTimingForm: ShiftTimingFormType = {
    shift: '',
    end_time: '',
    start_time: '',
    effective_start_date: '',
    effective_end_date: '',
    disabled: false,
    is_enabled: true,
  }
  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    setValue: setValueForm2,
    watch: watchForm2,
    formState: { errors: errorsForm2 },
    reset: resetForm2,
    trigger: triggerForm2,
  } = useForm({
    defaultValues: ShiftTimingForm,
  })
  const columnList: TableColumnType<DataTypeStore>[] = [
    {
      header: APPLICATION_PREFERENCES.SHIFT,
      accessor: 'shift',
      isSortable: true,
    },
    {
      header: APPLICATION_PREFERENCES.START_TIME,
      accessor: 'start_time',
      isSortable: true,
    },
    {
      header: APPLICATION_PREFERENCES.END_TIME,
      accessor: 'end_time',
      isSortable: true,
    },
    {
      header: APPLICATION_PREFERENCES.EFFECTIVE_START_DATE,
      accessor: 'effective_start_date',
      isSortable: true,
    },
    {
      header: APPLICATION_PREFERENCES.EFFECTIVE_END_DATE,
      accessor: 'effective_end_date',
      isSortable: true,
    },
  ]
  const actions: TableActionType<DataTypeStore>[] = [
    {
      label: APPLICATION_PREFERENCES.RENAME_THIS_SHIFT,
      key: APPLICATION_PREFERENCES.EDIT,
      accessor: APPLICATION_PREFERENCES.EDIT,
      showInPopUp: false,
      type: APPLICATION_PREFERENCES.EDIT,
      isEnabledOnDisabledRow: false,
    },
    {
      label: APPLICATION_PREFERENCES.ENABLED,
      key: APPLICATION_PREFERENCES.ENABLED,
      accessor: APPLICATION_PREFERENCES.ENABLED,
      showInPopUp: false,
      type: APPLICATION_PREFERENCES.TOGGLE,
      isEnabledOnDisabledRow: false,
    },
  ]
  const onSortClick = (key: string, isAsc: SORT_KEYS) => {
    if (key) {
      const newKeyName = convertToCamelCase(key)
      setSortDirection({
        keyName: isAsc === SORT_KEYS.Disabled ? '' : newKeyName,
        direction: isAsc,
        key: isAsc === SORT_KEYS.Disabled ? '' : key,
        isAsc: isAsc,
      })
    }
  }
  const onActionClick = (
    actionKeyName: string,
    row: DataTypeStore | null,
    _rowIndex: number
  ) => {
    switch (actionKeyName) {
      case APPLICATION_PREFERENCES.ENABLED:
        setModal({
          type: APPLICATION_PREFERENCES.TOGGLE,
          state: true,
          index: _rowIndex,
        })
        break
      case APPLICATION_PREFERENCES.EDIT:
        if (row) {
          handleCancel()
          setEditState({
            isEdit: true,
            index: _rowIndex,
            id: row?.id as number,
          })
          data[_rowIndex].disabled = true
          setValueForm2('shift', row?.shift as string)
          setValueForm2(
            'start_time',
            convertTo24HourFormat(row?.start_time as string)
          )
          setValueForm2(
            'end_time',
            convertTo24HourFormat(row?.end_time as string)
          )
        }
        break
      default:
        break
    }
  }
  const handleToggle = async (index: number) => {
    try {
      dispatch(showLoader())
      if (index === undefined) return
      const enabled = data[index].is_enabled
      const temp = {
        id: data[index].id as number,
        enabled: !enabled,
      }
      setModal({ type: '', state: false, index: undefined })
      const response = await patchShift(temp)
      if (response) {
        fetchDataShifts(sortDirection, rowsPerPage, currentPage)
        handleCancel()
      }
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }
  }
  const handleUserPageChange = (page: number, rowsPerPage: number) => {
    setRowsPerPage(rowsPerPage)
    fetchDataShifts(sortDirection, rowsPerPage, page)
    setCurrentPage(page)
  }
  const handleCancel = () => {
    if (editState) {
      if (data) {
        setData((prevData) => {
          const updatedData = [...prevData]
          if (editState.index !== undefined && editState?.index >= 0) {
            updatedData[editState.index].disabled = false
          }

          return updatedData
        })
      }
    }
    setEditState({
      isEdit: false,
      index: undefined,
      id: undefined,
    })
    if (setValueForm2) {
      setValueForm2('shift', '')
      setValueForm2('start_time', '')
      setValueForm2('end_time', '')
    }
  }
  const processShiftData = (shifts: ShiftDetails[]) => {
    return (shifts ?? [])?.map((item: ShiftDetails) => ({
      created_at: item.created_at,
      modified_at: item.modified_at,
      modified_by: item.modified_by,
      id: item.id,
      shift: item.shift,
      start_time: convertISOToTime(item.start_time),
      end_time: convertISOToTime(item.end_time),
      effective_start_date: convertISOToDate(item.effective_start_date),
      effective_end_date: convertISOToDate(item.effective_end_date),
      is_enabled: item.is_enabled,
      is_deleted: item.is_deleted,
      deleted_time: item.deleted_time,
    })) as DataTypeStore[]
  }
  const fetchDataShifts = async (
    sortDirection: {
      keyName: string
      direction: SORT_KEYS
      isAsc: SORT_KEYS
      key: string
    },
    rowsPerPage: number,
    page: number
  ) => {
    try {
      dispatch(showLoader())
      const shifts = await getShiftsData(sortDirection, rowsPerPage, page)
      setTotalPages(shifts.data.totalPages)
      setData(processShiftData(shifts.data?.content))
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const ShiftTimingFormSubmit = async (formData: ShiftTimingFormType) => {
    try {
      dispatch(showLoader())

      const newShift = {
        shift: formData.shift.trim(),
        start_time: convertTimeToISO(formData.start_time),
        end_time: convertTimeToISO(formData.end_time),
        effective_end_date: '2099-12-31',
      }
      if (editState.isEdit) {
        const editedShift = {
          shift: formData.shift.trim(),
          id: editState.id,
        }
        const response = await updateShiftData(editedShift)
        if (response) {
          await fetchDataShifts(sortDirection, rowsPerPage, currentPage)
        }
        setValueForm2('shift', '')
        setValueForm2('start_time', '')
        setValueForm2('end_time', '')
        setEditState({
          isEdit: false,
          index: undefined,
          id: undefined,
        })
        dispatch(
          addToaster({
            message: APPLICATION_PREFERENCES_STRINGS.SHIFT_UPDATED_MESSAGE,
            type: 'success',
            id: uuid(),
          })
        )
      } else {
        const response = await addShiftData(newShift)
        if (response) {
          await fetchDataShifts(sortDirection, rowsPerPage, currentPage)
        }
        setValueForm2('shift', '')
        setValueForm2('start_time', '')
        setValueForm2('end_time', '')
        setEditState({
          isEdit: false,
          index: undefined,
          id: undefined,
        })
        dispatch(
          addToaster({
            message: APPLICATION_PREFERENCES_STRINGS.SHIFT_ADDED_MESSAGE,
            type: 'success',
            id: uuid(),
          })
        )
      }
    } catch (error) {
      console.error(error)
      dispatch(
        addToaster({
          message: APPLICATION_PREFERENCES_STRINGS.NAME_ALREADY_EXIST,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }
  useEffect(() => {
    fetchDataShifts(sortDirection, rowsPerPage, currentPage)
    handleCancel()
  }, [sortDirection])
  useEffect(() => {
    provideSetData(setData)
  }, [provideSetData])
  return (
    <>
      <div className="border p-3 rounded-md">
        <div className="flex flex-col">
          <div className="flex grid-cols-2 justify-between">
            <h2 className="text-base col-span-1 font-primary font-bold">
              {APPLICATION_PREFERENCES.SHIFT_TIMINGS}
            </h2>
          </div>
          <h2>{`${APPLICATION_PREFERENCES_STRINGS.SHIFT_TIMINGS_MESSAGE}${
            shortKey.length > 0 ? ` (${shortKey})` : ''
          }`}</h2>
        </div>
        <form onSubmit={handleSubmitForm2(ShiftTimingFormSubmit)}>
          <div className="flex justify-between border px-2.5 py-3.5 rounded-md mt-2">
            <div className="grid grid-cols-10 gap-4 w-full">
              <div className="col-span-4">
                <FormInput
                  label={APPLICATION_PREFERENCES.SHIFT}
                  placeholder="--"
                  errors={errorsForm2}
                  name={'shift'}
                  register={registerForm2}
                  validation={{ required: true }}
                  dataQaId="inputShiftTimings"
                />
              </div>
              <div className="col-span-2">
                <FormInput
                  label={APPLICATION_PREFERENCES.START_TIME}
                  placeholder="--"
                  errors={errorsForm2}
                  name={'start_time'}
                  register={registerForm2}
                  validation={{
                    required: APPLICATION_PREFERENCES_STRINGS.REQUIRED_FIELD,
                    validate: () => {
                      const momentStartTime = moment(
                        watchForm2('start_time'),
                        'HH:mm'
                      )
                      const endTime = watchForm2('end_time')
                      if (endTime && endTime.length > 0) {
                        const momentEndTime = moment(endTime, 'HH:mm')
                        if (momentStartTime.isSame(momentEndTime)) {
                          return APPLICATION_PREFERENCES_STRINGS.START_TIME_CANNOT_LATER_END_TIME
                        }
                      }
                      return true
                    },
                  }}
                  disabled={editState.isEdit}
                  type="time"
                  dataQaId="startTimeInShiftTimings"
                  onChange={(e) => {
                    const newValue = e.target.value
                    setValueForm2('start_time', newValue)
                    triggerForm2('start_time')
                    triggerForm2('end_time')
                    triggerForm2('shift')
                  }}
                />
              </div>
              <div className="col-span-2">
                <FormInput
                  label={APPLICATION_PREFERENCES.END_TIME}
                  placeholder="--"
                  errors={errorsForm2}
                  name={'end_time'}
                  register={registerForm2}
                  validation={{
                    required: APPLICATION_PREFERENCES_STRINGS.REQUIRED_FIELD,
                  }}
                  disabled={editState.isEdit}
                  type="time"
                  dataQaId="endTimeInShiftTimings"
                  onChange={(e) => {
                    const newValue = e.target.value
                    setValueForm2('end_time', newValue)
                    triggerForm2('start_time')
                    triggerForm2('end_time')
                    triggerForm2('shift')
                  }}
                />
              </div>
            </div>
            {editState.isEdit ? (
              <div className="flex items-center gap-4">
                <div className="flex items-center justify-center">
                  <CustomButton
                    color="primary"
                    isFilled={false}
                    className="h-[2.375rem] border-none"
                    onClick={handleCancel}
                    dataQaId="cancelShiftTimings"
                  >
                    <span className=" font-primary">
                      {APPLICATION_PREFERENCES.CANCEL}
                    </span>
                  </CustomButton>
                </div>
                <div className="flex items-center justify-center">
                  <CustomButton
                    color="primary"
                    isFilled={true}
                    className="h-[2.375rem]"
                    type="submit"
                    dataQaId="updateShiftTimings"
                  >
                    <span className=" font-primary">
                      {APPLICATION_PREFERENCES.UPDATE}
                    </span>
                  </CustomButton>
                </div>
              </div>
            ) : (
              <div className="flex items-center gap-4">
                <div className="flex items-center justify-center">
                  <CustomButton
                    color="primary"
                    isFilled={false}
                    className="h-[2.375rem] border-none"
                    onClick={() => {
                      resetForm2()
                    }}
                    dataQaId="clearShiftTimings"
                  >
                    <span className=" font-primary">
                      {APPLICATION_PREFERENCES.CLEAR}
                    </span>
                  </CustomButton>
                </div>
                <div className="flex items-center justify-center">
                  <CustomButton
                    color="primary"
                    isFilled={true}
                    className="h-[2.375rem]"
                    type="submit"
                    dataQaId="addShiftInShiftTimings"
                  >
                    <span className=" font-primary">
                      {APPLICATION_PREFERENCES.ADD_SHIFT}
                    </span>
                  </CustomButton>
                </div>
              </div>
            )}
          </div>
        </form>
        <div className="custom-shadow bg-white rounded p-3 mt-2">
          <CustomTable
            data={data}
            columns={columnList}
            actions={actions}
            onActionClick={onActionClick}
            disabledKey="disabled"
            onSortClick={onSortClick}
            sort={
              sortDirection.key && !isEmpty(sortDirection?.key)
                ? { key: sortDirection?.key, isAsc: sortDirection?.isAsc }
                : null
            }
            maxHeight="calc(100vh - 19rem)"
          />
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages || 0}
            onPageChange={handleUserPageChange}
          />
        </div>
      </div>
      <ConfirmDialog
        message={
          modal?.index && data[modal?.index]?.is_enabled
            ? APPLICATION_PREFERENCES_STRINGS.DISABLE_SHIFT
            : APPLICATION_PREFERENCES_STRINGS.ENABLE_SHIFT
        }
        onConfirm={
          modal.type === 'toggle' ? () => handleToggle(modal?.index ?? 0) : noop
        }
        onCancel={() => setModal({ type: '', state: false, index: undefined })}
        open={modal.type === 'toggle'}
      />
    </>
  )
}
export default ShiftTiming
